import Vue from 'vue'
import moment from './moment'

Vue.filter('moment', moment)


// WEBPACK FOOTER //
// ./src/filters/index.js